import { Observable } from 'rxjs';
import { tag } from 'rxjs-spy/operators';

export function taggedNamespace(namespace: string | undefined) {
  if (!namespace) return tag;
  return <T>(name: string) =>
    (source$: Observable<T>) =>
      source$.pipe(tag(`${namespace}-${name}`));
}
